module.exports = __webpack_public_path__ + "img/bg_bizhongxiangqing.38d187b0.png";